import { useEffect } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useNavigation } from "../../../../portal";
import { useAuthenticationContext, useExpertProfileContext } from "../../..";
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageContext } from "../../../hooks/expert-message/ExpertMessageContext";
const ExpertMessage = ({
  children
}) => {
  const {
    message,
    messageResources,
    corruptUserSession,
    refreshMessage,
    setCorruptUserSession
  } = useExpertMessageContext();
  const {
    isAuthenticated
  } = useAuthenticationContext();
  const {
    profile,
    updateOnboaridngInviteCheck
  } = useExpertProfileContext();
  const {
    navigate
  } = useNavigation();
  const {
    isOnboaridngInviteChecked
  } = profile;
  useEffect(() => {
    if (isAuthenticated && isOnboaridngInviteChecked) {
      navigate("/onboarding");
      updateOnboaridngInviteCheck(false);
    }
  }, [isAuthenticated, isOnboaridngInviteChecked]);
  useEffect(() => {
    var _message$dialogues;
    let interval = 0;
    if ((message === null || message === void 0 ? void 0 : (_message$dialogues = message.dialogues) === null || _message$dialogues === void 0 ? void 0 : _message$dialogues.length) !== 0) {
      var _message$dialogues2;
      const filterMessage = message === null || message === void 0 ? void 0 : (_message$dialogues2 = message.dialogues) === null || _message$dialogues2 === void 0 ? void 0 : _message$dialogues2.filter(message => message.attachments !== null);
      const foundImageStatus = filterMessage === null || filterMessage === void 0 ? void 0 : filterMessage.filter(filterMessage => {
        var _filterMessage$attach;
        return (filterMessage === null || filterMessage === void 0 ? void 0 : filterMessage.attachments) && (filterMessage === null || filterMessage === void 0 ? void 0 : (_filterMessage$attach = filterMessage.attachments[0]) === null || _filterMessage$attach === void 0 ? void 0 : _filterMessage$attach.scannedStatus) === null;
      });
      if ((foundImageStatus === null || foundImageStatus === void 0 ? void 0 : foundImageStatus.length) > 0) {
        interval = setInterval(() => onRefreshMessage(), 40000);
      }
    }
    return () => {
      clearInterval(interval);
    };
  }, [message]);
  const onRefreshMessage = () => {
    refreshMessage(message, profile);
  };
  const log = pilog.getLogger("ExpertMessage");
  log.debug(message.lastStateCalculation);
  return children({
    message,
    messageResources,
    corruptUserSession,
    setCorruptUserSession
  });
};
export default ExpertMessage;
ExpertMessage.propTypes = {
  children: PropTypes.func.isRequired
};